import * as CSS from 'csstype';
import * as  React from 'react';

type Props = {
    children: React.ReactNode,
    footer?: React.ReactNode,
}
export default function ForecastingCard(
    {
        children,
        footer
    }: Props): JSX.Element {
    return (
        <div style={cardSettings}>
            <div style={cardBlueStrip}/>
            <div style={cardContent}>
                {children}
            </div>
            <div style={cardFooter}>
                {footer}
            </div>
        </div>
    );
}

const cardSettings: CSS.Properties = {
    borderRadius: '15px',
    backgroundColor: 'white',
    boxShadow: '0 2px 5.33px 0 rgba(23, 37, 61, 0.2), 0 0 2px 0 rgba(23, 37, 61, 0.14), 0 2px 2px 0 rgba(23, 37, 61, 0.12)',
    pointerEvents: 'auto',
    maxHeight: '100%',
}

const cardBlueStrip: CSS.Properties = {
    width: '100%',
    backgroundColor: '#004FC2',
    height: '12px',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
}

const cardContent: CSS.Properties = {
    padding: '16px',
    color: 'text-gray-700',
    fontSize: '16px',
    maxHeight: '68vh',
    overflow: 'auto',
}

const cardFooter: CSS.Properties = {
    padding: '16px',
    color: 'text-gray-700',
    fontSize: '16px',
}

